import { useState, type FormEvent } from "react";
import { AuthLayout } from "./auth-layout";
import { ApiError } from "@/api/client";
import { useSession } from "@/api/session";
import { Button } from "@/components/ui/button";
import { Icon } from "@/components/ui/icon";
import { LabelledInput } from "@/components/ui/field";

export function LoginPage() {
  const login = useSession((s) => s.login);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(event: FormEvent) {
    event.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await login(email.trim(), password, rememberMe);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "Something went wrong. Try again.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <AuthLayout
      title="Sign in"
      sub="Use your Mentoria work email. First time in? Sign in with the one-time password HR gave you and you'll be asked to set your own."
    >
      <form onSubmit={onSubmit} className="flex flex-col gap-4" noValidate>
        {error && (
          <p
            role="alert"
            className="flex items-start gap-2 rounded-lg bg-bad-wash px-3 py-2.5 text-[13px] leading-relaxed text-bad"
          >
            <Icon name="warning-circle" size={16} className="mt-0.5" />
            <span>{error}</span>
          </p>
        )}

        <LabelledInput
          label="Work email"
          type="email"
          autoComplete="username"
          required
          placeholder="you@mentoria.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <LabelledInput
          label="Password"
          type="password"
          autoComplete="current-password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <label className="flex items-center gap-2 text-[13px] text-ink-soft">
          <input
            type="checkbox"
            className="h-4 w-4 rounded border-line-strong accent-accent"
            checked={rememberMe}
            onChange={(e) => setRememberMe(e.target.checked)}
          />
          Remember me
        </label>

        <Button type="submit" variant="primary" size="lg" loading={busy} className="mt-1 w-full">
          Sign in
        </Button>
      </form>
    </AuthLayout>
  );
}
